import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useLoadingActions } from "../../../context&providers/providers/Loading";
import { resendOtp } from "../../../services/api/OnboardingServices";
import { ResendOtpLabel } from "../login.styles";
import { ErrorMessage } from "@corporate-trip-planner-fe/ui-styles";
var resendOtpCounter = 30;
var ResendOtp = function (_a) {
    var email = _a.email;
    var _b = useState(''), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = useState(true), isResendDisabled = _c[0], setIsResendDisabled = _c[1];
    var _d = useState(resendOtpCounter), resendCountdown = _d[0], setResendCountdown = _d[1];
    var _e = useLoadingActions(), showLoading = _e.showLoading, hideLoading = _e.hideLoading;
    var handleResendOtp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setIsResendDisabled(true);
                    return [4 /*yield*/, resendOtp(email)];
                case 1:
                    _a.sent();
                    setResendCountdown(resendOtpCounter); // Start the countdown
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Failed to resend OTP:", error_1);
                    setErrorMessage("Failed to resend OTP. Please try again.");
                    setIsResendDisabled(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var countdownInterval = null;
        if (resendCountdown > 0) {
            countdownInterval = setInterval(function () {
                setResendCountdown(function (prev) {
                    if (prev <= 1) {
                        clearInterval(countdownInterval);
                        setIsResendDisabled(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return function () {
            if (countdownInterval)
                clearInterval(countdownInterval);
        };
    }, [resendCountdown]);
    return (_jsxs(_Fragment, { children: [errorMessage && _jsx(ErrorMessage, { children: errorMessage }), _jsx(ResendOtpLabel, { onClick: isResendDisabled ? undefined : handleResendOtp, isResendDisabled: isResendDisabled, children: isResendDisabled ? "Resend OTP in ".concat(resendCountdown, "s") : "Resend OTP" })] }));
};
export default ResendOtp;
